module.exports = __webpack_public_path__ + "img/save-remove.46defc77.svg";